import React from 'react';
import { Box, } from '@mui/material';
import { Helmet, } from 'react-helmet';
import { useIntl, } from 'react-intl';
import Block1 from './component/Block1';
import Block2 from './component/Block2';
import Block3 from './component/Block3';

const Harassment = () => {
  const intl = useIntl();

  // meta tag文案
  const pageTitle = intl.formatMessage({ id: 'harassment.page.title', });
  const ogTagTitle = intl.formatMessage({ id: 'harassment.page.ogtag.title', });
  const ogTagDescription = intl.formatMessage({ id: 'harassment.page.ogtag.description', });

  return (
    <Box>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={ogTagDescription}
        ></meta>
        <meta
          property="og:title"
          content={ogTagTitle}
        />
        <meta
          property="og:description"
          content={ogTagDescription}
        />
      </Helmet>
      <Block1 />
      <Block2 />
      <Block3 />
    </Box>
  );
};

export default React.memo(Harassment);